module.exports = __webpack_public_path__ + "img/create-option.4ca7bdb9.svg";